export const HOSPITAL_NETWORK_PAGE_URL = '/hospital-network';
